<script setup lang="ts">
const props = defineProps<{
  title?: StoryBlokHeading
  isSingleRow?: boolean
  items: ProductTileNormalItem[] | ProductTileEnterpriseItem[]
  enableSingleCol?: boolean
}>()
</script>

<template>
  <StoryblokProductTiles v-editable="props" class="content-container" v-bind="props" />
</template>
